export const GET_FUEL_REPORT_PREVIEW = 'GET_FUEL_REPORT_PREVIEW';
export const CLEAR_FUEL_REPORT_PREVIEW = 'CLEAR_FUEL_REPORT_PREVIEW';
export const FLAG_FUEL_REPORT_PREVIEW_ACTIVITY =
  'FLAG_FUEL_REPORT_PREVIEW_ACTIVITY';
